import { useSelector } from 'react-redux';
import { SearchTermsFiltersQueryWithSearchTerms } from 'src/context/api/non-branded/query';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';
import { RootState } from 'src/context/store';
import { fDate } from 'src/utils/format-time';
import { useNonBrandPlatforms } from './use-non-brand-platforms';

/** Filter args shared by every Non Brand Search Performance query (header filters + CountryBar). */
export function useNonBrandFilterArgs(): SearchTermsFiltersQueryWithSearchTerms {
  const workspace = useCurrentWorkspace();
  const filters = useSelector((state: RootState) => state.filters);
  // A platform picked on a Brand page but absent from the Non Brand data would empty the page, with the pill
  // hidden (single platform) or without that option: it is ignored here, the shared selection is left alone
  const nonBrandPlatforms = useNonBrandPlatforms();
  const platforms = nonBrandPlatforms ? filters.platforms.filter((p) => nonBrandPlatforms.includes(p)) : filters.platforms;
  return {
    workspace_id: workspace?.id as number,
    start_date: fDate(filters.start, 'yyyy-MM-dd'),
    end_date: fDate(filters.end, 'yyyy-MM-dd'),
    devices: filters.devices,
    countries: filters.countries,
    platforms,
    search_terms: filters.keywords,
    tags: filters.tags.map((tag) => tag.label),
  };
}
